import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import { useRef as r, useDebugValue as e } from "react";
import "./useState.js";
import t from "./useForceUpdate.js";

var useMap = function useMap(n) {
  var u = t(),
      c = r(new Map(n)),
      a = new Map(c.current);
  return a.clear = function () {
    c.current.size > 0 && (c.current.clear(), u());
  }, a["delete"] = function (r) {
    var e = c.current["delete"](r);
    return e && u(), e;
  }, a.set = function (r, e) {
    var t = c.current.set(r, e);
    return u(), t;
  }, e(a), a;
};

export default useMap;